/**
 * Подписи лицевого счёта.
 *
 * Источник операции бэк отдаёт строкой-перечислением, но типом не
 * закрывает — значит, завтра там может появиться новое значение.
 * Поэтому ни один справочник здесь не «закрытый»: незнакомый код
 * показываем как есть. Пустая строка вместо «freedompay_payment»
 * выглядела бы как сломанная вёрстка, а не как новый источник.
 */

import dayjs from 'dayjs';

import type {LedgerEntry, LedgerSource} from '@services/ledger';
import {formatTiyin} from '@utils/format';

const SOURCE_LABEL: Record<string, string> = {
  freedompay_payment: 'Оплата картой',
  manual_topup: 'Пополнение вручную',
  subscription_charge: 'Списание абонентки',
  refund: 'Возврат',
  adjustment: 'Корректировка',
};

export const sourceLabel = (source: LedgerSource): string =>
  SOURCE_LABEL[source] ?? (source || 'Операция');

/**
 * Сумма со знаком: приход «+», расход «−». Знак даёт `kind`, поэтому
 * саму сумму берём по модулю — иначе отрицательное значение из ответа
 * нарисовало бы «−-500 сом».
 */
export const signedAmount = (e: LedgerEntry): string =>
  `${e.kind === 'credit' ? '+' : '−'}${formatTiyin(Math.abs(e.amountTiyin))}`;

export const fmtLedgerDate = (iso: string): string =>
  iso ? dayjs(iso).format('D MMM YYYY, HH:mm') : '—';

/**
 * Оплаченный период у списания абонентки. Приходит не у всех операций —
 * показываем только когда есть обе границы, иначе строка «с 1 янв по —»
 * читается как ошибка данных.
 */
export const periodLabel = (e: LedgerEntry): string | null => {
  if (!e.periodStart || !e.periodEnd) return null;
  return `${dayjs(e.periodStart).format('D MMM')} — ${dayjs(e.periodEnd).format('D MMM YYYY')}`;
};
